import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { markLatestActiveSymbolIndexTask, enqueueSymbolIndexTask } from './task-queue-enqueue.js';
import { scheduleSymbolIndexWarmup } from './symbol-index-warmup.js';

let requestSeq = 0;

/** High-priority indexing for a file the user is actively viewing. */
export function scheduleSymbolIndexFile(parentPath: string, filePath: string): void {
  const sequence = ++requestSeq;
  markLatestActiveSymbolIndexTask(parentPath, sequence);
  enqueueSymbolIndexTask(parentPath, filePath, 1_000_000 + sequence, sequence);
}

/** Schedule direct import targets after a request file is indexed. */
export function scheduleSymbolIndexImportNeighbors(parentPath: string, filePaths: readonly string[]): void {
  let priority = 500_000 + requestSeq;
  for (const filePath of filePaths) {
    enqueueSymbolIndexTask(parentPath, filePath, priority, requestSeq);
    priority -= 1;
  }
}

export { scheduleSymbolIndexWarmup } from './symbol-index-warmup.js';

/** Prime request path, neighbors, then background warmup without blocking the caller. */
export function scheduleSymbolIndexForRequest(
  parentPath: string,
  reqPath: string,
  importTargets: readonly string[],
): void {
  scheduleSymbolIndexFile(parentPath, reqPath);
  scheduleSymbolIndexImportNeighbors(parentPath, importTargets);
  scheduleSymbolIndexWarmup(parentPath);
}
